import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { TypePathDetailTableComponent } from './type-path-detail-table.component';
@NgModule({
    declarations: [TypePathDetailTableComponent],
    exports: [TypePathDetailTableComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
})
export class TypePathDetailTableModule { }
